import React from "react";

import InnerClientLayout from "@/components/layout/client/InnerClientLayout";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/v2/card";
import PageLayout from "@/pages/page-layout/PageLayout";
import { BreadcrumbType } from "@/types/breadcrumb-types";

interface GeneralLayoutWrapperProps {
  children: React.ReactNode;
  breadcrumb?: BreadcrumbType;
  title?: string;
  subHeader?: string;
  actionButton?: React.ReactNode;
  excludeInnerLayout?: boolean;
}

const GeneralLayoutWrapper: React.FC<GeneralLayoutWrapperProps> = ({
  children,
  breadcrumb,
  title,
  subHeader,
  actionButton,
  excludeInnerLayout = false,
}) => {
  const defaultBreadcrumb: BreadcrumbType = {
    currentPage: { label: title || "Page" },
  };

  const renderChildren = () =>
    excludeInnerLayout ? (
      children
    ) : (
      <InnerClientLayout>{children}</InnerClientLayout>
    );

  return (
    <PageLayout breadcrumb={breadcrumb || defaultBreadcrumb}>
      <Card>
        {(title || subHeader || actionButton) && (
          <CardHeader>
            {title && <CardTitle>{title}</CardTitle>}
            {subHeader && <CardDescription>{subHeader}</CardDescription>}
            {actionButton && <CardAction>{actionButton}</CardAction>}
          </CardHeader>
        )}
        <CardContent>{renderChildren()}</CardContent>
      </Card>
    </PageLayout>
  );
};

export default GeneralLayoutWrapper;
